import { api } from '../lib/api.js';

// Entry point React-idiomático hacia el cliente HTTP compartido (lib/api.ts),
// que ya inyecta el header Authorization automáticamente en cada llamada.
export function useApi() {
  return api;
}
